import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import InputMask from "react-input-mask";
import { toast } from 'react-toastify';
import { useGetDriverNumberQuery, useGetPayrollCycleQuery } from "../../../features/admin/employee/employeeSlice";
import { useAddInterlinerMutation, useAddSwitchTypeQuery, useGetInterlinerAgentQuery, useGetReportTypeQuery, useUpdateInterlinerMutation } from "../../../features/Interliners/InterlinersFieldsSlice";
import CountryProvince from "../../CountryProvince";
import postalCodeMasking from "../../Customer/PostalCodeMasking";
import TextField from "../../designSystem/TextField";
import errorHandler from "../../hooks/ErrorHanlder";
import AutocompleteAddressData from "./AutoCompleteAddressData";
import TimePicker from "../../designSystem/TimePicker";

const initialData = {
    contact: "", openTime: "", closeTime: "", locationNotes: "",
    billingCity: "", billingStreetNo: "", billingStreetName: "", billingProvince: "", billingCountry: "", billingPostalCode: "",
    dockCity: "", dockCountry: "", dockPostalCode: "", dockProvince: "", dockProvinceID: "", dockStreetName: "", dockStreetNo: "", city: "",
    driverNumber: "", driverId: "", companyName: "", switchtypeId: "", csaApprovedDriver: false, streetNumber: "", streetName: "", unit: "", cityID: "", postalCode: "",
    phoneExtension: "", fax: "", primaryNumber: "", secondaryNumber: "", tollFreeNo: "", hireDate: "", payrollCycleId: "", cdnpars: "", usapaps: "", dockName: "", ourAccount: "",
    insuranceInfo: "", renewalDate: "", wsaibAccountNumber: "", wsibFirm: "", wsibFirmRenewalDate: "", emailFTProuting: false, email: "", ccEmialAddress: "", countryId: "",
    provineStateID: "", reportTypeID: "", alphaCode: ""
};

const AddInterliners = ({ mode, closeForm, rateCardSection, interlinerDetails, interlinerRowData, bb }) => {
    const { city, newHandleCountry, handleProvince } = CountryProvince()
    const cityList = city?.data.map((a) => { return { name: a.city, id: a.id } });
    const { refetch } = useGetInterlinerAgentQuery()
    const cityData = interlinerRowData?.cityID
        ? [{ name: interlinerRowData.city, id: interlinerRowData.cityID }]
        : [];
    const dockData = interlinerRowData?.dockCity ? [{ name: interlinerRowData?.dockCity, id: interlinerRowData?.dockCityID }] : []
    const billingCityData = interlinerRowData?.billingCity ? [{ name: interlinerRowData?.billingCity, id: interlinerRowData?.billingCityID }] : []
    const { register, handleSubmit, setValue, formState: { errors }, reset, control, watch } = useForm({
        defaultValues: mode === "EDIT" ? {
            contact: interlinerRowData.contact, openTime: interlinerRowData.openTime, closeTime: interlinerRowData.closeTime, locationNotes: interlinerRowData.locationNotes,
            billingCity: billingCityData,
            dockCity: dockData,
            dockCountry: interlinerRowData?.dockCountry,
            dockPostalCode: interlinerRowData?.dockPostalCode,
            dockProvince: interlinerRowData?.dockProvince,
            dockProvinceID: interlinerRowData?.dockProvinceID,
            dockStreetName: interlinerRowData?.dockStreetName,
            dockStreetNo: interlinerRowData?.dockStreetNo,
            companyName: interlinerRowData?.companyName ?? "",
            streetNumber: interlinerRowData?.streetNumber ?? "",
            streetName: interlinerRowData?.streetName ?? "",
            unit: interlinerRowData?.unit ?? "",
            postalCode: interlinerRowData?.postalCode ?? "",
            phoneExtension: interlinerRowData?.phoneExtension ?? "",
            fax: interlinerRowData?.fax ?? "",
            primaryNumber: interlinerRowData?.primaryNumber ?? "",
            secondaryNumber: interlinerRowData?.secondaryNumber ?? "",
            tollFreeNo: interlinerRowData?.tollFreeNo ?? "",
            hireDate: interlinerRowData?.hireDate ? moment(interlinerRowData?.hireDate).utc().format('YYYY-MM-DD') : "",
            cdnpars: interlinerRowData?.cdnpars ?? "",
            usapaps: interlinerRowData?.usapaps ?? "",
            ourAccount: interlinerRowData?.ourAccount ?? "",
            insuranceInfo: interlinerRowData?.insuranceInfo ?? "",
            wsaibAccountNumber: interlinerRowData?.wsaibAccountNumber ?? "",
            wsibFirm: interlinerRowData?.wsibFirm ?? "",
            wsibFirmRenewalDate: interlinerRowData?.wsibFirmRenewalDate ? moment(interlinerRowData?.wsibFirmRenewalDate).utc().format('YYYY-MM-DD') : "",
            email: interlinerRowData?.email ?? "",
            ccEmialAddress: interlinerRowData?.ccEmialAddress ?? "",
            driverId: interlinerRowData?.driverId ?? "",
            switchtypeId: interlinerRowData?.switchtypeId ?? "",
            countryId: interlinerRowData?.countryId ?? "",
            cityID: cityData,
            renewalDate: interlinerRowData?.renewalDate ? moment(interlinerRowData?.renewalDate).utc().format('YYYY-MM-DD') : "",
            reportTypeID: interlinerRowData?.reportTypeID ?? "",
            provineStateID: interlinerRowData?.provineStateID ?? "",
            csaApprovedDriver: interlinerRowData?.csaApprovedDriver ?? false,
            emailFTPRouting: interlinerDetails?.emailFTPRouting ?? false,
            payrollCycleId: interlinerRowData?.payrollCycleId ?? "",
            disPathcherId: interlinerRowData?.disPathcherId ?? "",
            alphaCode: interlinerRowData?.alphaCode ?? "",
            driverNumber: interlinerRowData?.driverNumber ?? "",
        } : initialData
    });
    const [addInterliner] = useAddInterlinerMutation()
    const { data: interliner } = useAddSwitchTypeQuery()
    const { data: reportType } = useGetReportTypeQuery()
    const { data: payrollCycle } = useGetPayrollCycleQuery()
    const { data: driverlist, refetch: driverlistRefetch } = useGetDriverNumberQuery()
    const [updateDatas] = useUpdateInterlinerMutation()
    const [postal, setPostal] = useState(mode === "ADD" ? "" : interlinerRowData?.postalCode)
    const [dlist, setDlist] = useState([])
    const cityOptions = city?.data.map((a) => ({ name: a.city, id: a.id })) || [];
    const billingCityOptions = city?.data.map((a) => ({ name: a.city, id: a.id })) || [];

    const resetHandler = () => {
        if (mode === "ADD") return
        reset({
            ...interlinerRowData,
            hireDate: interlinerRowData.hireDate ? moment(interlinerRowData.hireDate).utc().format('YYYY-MM-DD') : "",
            wsibFirmRenewalDate: interlinerRowData.wsibFirmRenewalDate ? moment(interlinerRowData.wsibFirmRenewalDate).utc().format('YYYY-MM-DD') : "",
            renewalDate: interlinerRowData.renewalDate ? moment(interlinerRowData.renewalDate).utc().format('YYYY-MM-DD') : "",
            cityID: cityData,
            dockCity: interlinerRowData?.dockCity ? [{ name: interlinerRowData?.dockCity, id: interlinerRowData?.dockCityId }] : [],
            billingCity: billingCityData
        });
    }

    useEffect(() => {
        const activeSwitchType = watch("switchtypeId") || (mode === "EDIT" ? interlinerRowData?.switchtypeId : "");

        let filtered = [];
        if (activeSwitchType == "1") {
            filtered = driverlist?.data?.filter(
                (driver) => driver?.driverType === "Interliner"
            ) || [];
        } else if (activeSwitchType == "2") {
            filtered = driverlist?.data?.filter(
                (driver) => driver?.driverType === "Agent"
            ) || [];
        } else {
            filtered = [];
        }

        if (mode === "EDIT" && interlinerRowData?.driverId) {
            // In EDIT mode, if the selected driver is not in the filtered list, add it.
            if (!filtered.some((driver) => driver.empDriverId == interlinerRowData.driverId)) {
                filtered = [
                    { empDriverId: interlinerRowData.driverId, driverNumber: interlinerRowData.driverNumber },
                    ...filtered,
                ];
            }
            resetHandler()
        }

        setDlist(filtered);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [driverlist, mode, interlinerRowData, watch]);


    const onSubmit = async (data) => {
        data.interlinersRateCardDTOs = rateCardSection
        data.disPathcherId = 1
        try {
            const submitData = await addInterliner({ ...data, cityID: data.cityID[0].id, dockCity: data.dockCity[0].name, billingCity: data.billingCity[0].name }).unwrap()
            reset(initialData)
            refetch()
            setPostal("")
            closeForm()
            driverlistRefetch()
            toast.success(submitData?.message, { position: "top-center" })
        } catch (error) {
            errorHandler(error)
        }
    }
    const onUpdate = async (data) => {
        data.updateinterlinersRateCardDTOs = bb
        const updateData = await updateDatas({ ...data, interlinersId: interlinerRowData?.interlinersId, payNumber: interlinerRowData?.payNumber, cityID: data.cityID[0].id, dockCity: data.dockCity[0].name, billingCity: data.billingCity[0].name }).unwrap()
        try {
            reset(initialData)
            refetch()
            driverlistRefetch()
            setPostal("")
            closeForm()
            toast.success(updateData?.message, { position: "top-center" })
        } catch (error) {
            errorHandler(error)
        }
    }

    const handleInput = e => {
        const formattedPostalCode = postalCodeMasking(e.target.value)
        if (e.target.name === "postalCode") {
            setPostal(formattedPostalCode)
        }
    };

    return (
        <div className="user-role-form mt-4 p-3" >
            <h3 className="card-title primary" style={{ fontSize: "14px" }}>Add Agent/Interliner</h3>
            <>
                <Row className="mb-3 justify-content-end">
                    <Col xs={`${mode === "ADD" ? 1 : "auto"}`} >
                        {
                            mode === "ADD" ?
                                <Button onClick={handleSubmit(onSubmit)}>Save</Button>
                                :
                                <Button onClick={handleSubmit(onUpdate)}>Update</Button>
                        }
                    </Col>
                    {mode !== "ADD" ? <Col xs="auto" className="ps-0">
                        <Button variant="outline-primary" onClick={closeForm}>Cancel</Button>
                    </Col> : null}
                </Row>
                <Row>
                    <Col sm={2}>
                        <Form.Group controlId="country">
                            <FloatingLabel controlId="floatingSelectGrid" label="Select Type">
                                <Form.Select aria-label="Floating label select example" name="switchtypeId"   {...register("switchtypeId", {
                                    required: "Field is required",
                                    onChange: (e) => {
                                        setValue("driverId", "");
                                        const value = e.target.value;
                                        if (value === "1") {
                                            setDlist(driverlist?.data?.filter(data => data?.driverType === "Interliner"));
                                        } else if (value === "2") {
                                            setDlist(driverlist?.data?.filter(data => data?.driverType === "Agent"));
                                        } else {
                                            setDlist([]);
                                        }
                                    }
                                })}>
                                    <option value="">Select</option>
                                    <>
                                        {interliner?.data?.map((data, index) => (
                                            <option key={index} value={data?.switchtypeId} >{data?.switchTypeName}</option>
                                        ))}
                                    </>
                                </Form.Select>
                            </FloatingLabel>
                            <p className="error-message">{errors.switchtypeId?.message}</p>
                        </Form.Group>
                    </Col>
                    <Col sm={2}>
                        <Form.Group controlId="country">
                            <FloatingLabel controlId="floatingSelectGrid" label="Select driver number">
                                <Form.Select aria-label="Floating label select example" name="driverId"   {...register("driverId", {
                                    required: "Field is required",
                                    onChange: (e) => {
                                        const selectedId = e.target.value;
                                        const selectedDriver = dlist?.find(
                                            (driver) => driver.empDriverId == selectedId
                                        );
                                        setValue("driverNumber", selectedDriver ? selectedDriver.driverNumber : "");
                                    }
                                })}>
                                    <option value="">Select</option>
                                    <>
                                        {
                                            dlist?.map((data, index) => {
                                                return <option key={index} value={data?.empDriverId}>{data?.driverNumber}</option>
                                            })
                                        }
                                    </>
                                </Form.Select>
                            </FloatingLabel>
                            <p className="error-message">{errors.driverId?.message}</p>
                        </Form.Group>
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Form.Control type="text" autoComplete="off" placeholder="Code" name="alphaCode" {...register('alphaCode', { required: dlist[0]?.driverType === "Agent" && 'Field is required' })} />
                            <label htmlFor="alphaCode">Code</label>
                            <p className="error-message">{errors.alphaCode?.message}</p>
                        </div>
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Form.Control type="text" autoComplete="off" placeholder="Company name" name="companyName" {...register('companyName', { required: 'Field is required' })} />
                            <label htmlFor="Company name">Company name</label>
                            <p className="error-message">{errors.companyName?.message}</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" name="csaAapprovedDriver"  {...register('csaApprovedDriver')} />
                            <label className="form-check-label" htmlFor="inlineCheckbox2" style={{ fontSize: "15px" }}>CSA Approved Carrier</label>
                        </div>
                    </Col>
                </Row>
                {/* 2nd Row */}
                <Row className="mt-2">
                    <Col sm={2}>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="Street No." name="streetNumber" {...register('streetNumber', { required: 'Field is required', pattern: (/^[0-9]+$/) })}
                                min="1" />
                            <label htmlFor="Street No.">Street No.</label>
                            <p className="error-message">{errors.streetNumber?.message}</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <Form.Control type="text" autoComplete="off" placeholder="Street Name" name="streetName" {...register('streetName', { required: 'Field is required', })} />
                            <label htmlFor="Street Name">Street Name</label>
                            <p className="error-message">{errors.streetName?.message}</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="Unit" name="unit" {...register('unit')}
                                min="1" />
                            <label htmlFor="Unit">Unit</label>
                            <p className="error-message">{errors.unit?.message}</p>
                        </div>
                    </Col>
                    <AutocompleteAddressData
                        control={control}
                        register={register}
                        setValue={setValue}
                        errors={errors}
                        cityOptions={cityList}
                        handleProvince={handleProvince}
                        newHandleCountry={newHandleCountry}
                        interlinerRowData={interlinerRowData}
                        defaultCityID={interlinerRowData?.cityID}
                        defaultProvinceID={interlinerRowData?.provineStateID}
                        resetHandler={resetHandler}
                    />
                </Row>
                <Row className="mt-2">
                    <Col sm={2}>
                        <div className="form-floating">
                            <Form.Control type="text" autoComplete="off" placeholder="Postal Code" name="postalCode" value={postal} {...register('postalCode', { required: " Field is required" })}
                                onChange={(e) => handleInput(e)} />
                            <label htmlFor="Postal Code">Postal Code</label>
                            <p className="error-message">{errors.postalCode?.message}</p>
                        </div>
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="Phone Extension" name="phoneExtension" {...register('phoneExtension',
                                { required: " Field is required", maxLength: { value: 5, message: "Maximum length is 5 characters" } })}
                                maxLength="5" />
                            <label htmlFor="Phone Extension">Phone Extension</label>
                            <p className="error-message">{errors.phoneExtension?.message}</p>
                        </div>
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Controller type="number" placeholder="Fax"
                                name="fax"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <InputMask mask="(999) - 999 9999" value={value || interlinerDetails?.fax || ""} onChange={onChange}>
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type="tel"
                                                className="form-control"
                                                placeholder="Fax"
                                                name="fax"
                                            />
                                        )}
                                    </InputMask>
                                )}
                                {...register("fax", { required: 'Field is required', minLength: { value: 4, message: 'Please enter 10 digit contact number' } })} />
                            <label htmlFor="contact">Fax</label>
                        </div>
                        {errors.fax?.message && (<p className="error-message">{" * " + errors.fax?.message}</p>)}
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Controller type="number" placeholder="Primary Number"
                                name="primaryNumber"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <InputMask mask="(999) - 999 9999" value={value || interlinerDetails?.primaryNumber || ""} onChange={onChange}>
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type="tel"
                                                className="form-control"
                                                placeholder="Primary Number"
                                                name="primaryNumber"
                                            />
                                        )}
                                    </InputMask>
                                )}
                                {...register("primaryNumber", { required: 'Field is required', minLength: { value: 4, message: 'Please enter 10 digit contact number' } })} />
                            <label htmlFor="contact">Primary Number</label>
                        </div>
                        {errors.primaryNumber?.message && (<p className="error-message">{" * " + errors.primaryNumber?.message}</p>)}
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Controller type="number" placeholder="Primary Number"
                                name="secondaryNumber"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <InputMask mask="(999) - 999 9999" value={value || interlinerDetails?.secondaryNumber || ""} onChange={onChange}>
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type="tel"
                                                className="form-control"
                                                placeholder="Secondary Number"
                                                name="secondaryNumber"
                                            />
                                        )}
                                    </InputMask>
                                )}
                                {...register("secondaryNumber", { required: 'Field is required', minLength: { value: 4, message: 'Please enter 10 digit contact number' } })} />
                            <label htmlFor="contact">Secondary Number</label>
                        </div>
                        {errors.secondaryNumber?.message && (<p className="error-message">{" * " + errors.secondaryNumber?.message}</p>)}
                    </Col>
                    <Col sm={2}>
                        <div className="form-floating">
                            <Controller type="number" placeholder="Toll Free No."
                                name="tollFreeNo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <InputMask mask="(999) - 999 9999" value={value || interlinerDetails?.tollFreeNo || ""} onChange={onChange}>
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type="tel"
                                                className="form-control"
                                                placeholder="Toll Free No."
                                                name="tollFreeNo"
                                            />
                                        )}
                                    </InputMask>
                                )}
                                {...register("tollFreeNo", { required: 'Field is required', minLength: { value: 4, message: 'Please enter 10 digit contact number' } })} />
                            <label htmlFor="contact">Toll Free No.</label>
                        </div>
                        {errors.tollFreeNo?.message && (<p className="error-message">{" * " + errors.tollFreeNo?.message}</p>)}
                    </Col>
                </Row>
                {/* 4th Row */}
                <Row className="mt-2">
                    <Col>
                        <TextField label="Contact" {...register("contact", { required: "Field is Required" })} error={errors?.contact?.message} />
                    </Col>
                    <Col>
                        <TimePicker label="Open Time" {...register("openTime", { required: "Field is Required" })} error={errors?.openTime?.message} />
                    </Col>
                    <Col>
                        <TimePicker label="Close Time" {...register("closeTime", { required: "Field is Required" })} error={errors?.closeTime?.message} />
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <Form.Control type="date" autoComplete="off" placeholder="Hire date" name="hireDate" {...register('hireDate', { required: 'Field is required', })} />
                            <label htmlFor="Hire date">Hire date</label>
                            <p className="error-message">{errors.hireDate?.message}</p>
                        </div>
                    </Col>
                    <Col>
                        <Form.Group controlId="City">
                            <FloatingLabel controlId="floatingSelectGrid" label="Select pay-cycle">
                                <Form.Select aria-label="Floating label select example" name="payrollCycleId" {...register('payrollCycleId', { required: !interlinerRowData && 'Field is required', })}>
                                    <option value="">Select</option>
                                    <>
                                        {payrollCycle?.data?.map((data, index) => (
                                            <option key={index} value={data?.payrollCycleId} selected={data?.payrollCycleId === interlinerRowData?.payrollCycleId}>{data?.payrollCyclename}</option>
                                        ))}
                                    </>
                                </Form.Select>
                            </FloatingLabel>
                            <p className="error-message">{errors.payrollCycleId?.message}</p>
                        </Form.Group>
                    </Col>
                </Row>
                {/* 5th row */}
                <Row>
                    <Col sm={4}>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="CDN P.A.R.S" name="cdnpars" {...register('cdnpars', { required: 'Field is required' })} />
                            <label htmlFor="CDN P.A.R.S">CDN P.A.R.S</label>
                            <p className="error-message">{errors.cdnpars?.message}</p>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="USA P.A.P.S" name="usapaps" {...register('usapaps', { required: 'Field is required' })} />
                            <label htmlFor="USA P.AP.S">USA P.AP.S</label>
                            <p className="error-message">{errors.usapaps?.message}</p>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="form-floating">
                            <Form.Control type="number" autoComplete="off" placeholder="Our account at the carrier" name="ourAccount" {...register('ourAccount', { required: ' Field is required' })} />
                            <label htmlFor="dockname">Our account at the carrier</label>
                            <p className="error-message">{errors.ourAccount?.message}</p>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col sm={12}>
                        <TextField style={{ minHeight: "100px" }} as="textarea" label="Location Notes" {...register("locationNotes", { required: "Field is Required" })} error={errors?.locationNotes?.message} />
                    </Col>
                </Row>
                {/* 6th row */}
                <fieldset className="user-role-form mt-3" style={{ background: "#e1e1e1" }}>
                    <Row className="3">
                        <Col sm={8}>
                            <div className="form-floating">
                                <Form.Control type="text" autoComplete="off" placeholder="Insurance info" name="insurenceInfo" {...register('insurenceInfo', { required: 'Field is required' })} />
                                <label htmlFor="Insurance info">insurance Info</label>
                                <p className="error-message">{errors.insurenceInfo?.message}</p>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className="form-floating">
                                <Form.Control type="date" autoComplete="off" placeholder="Renewal date" name="renewalDate" {...register('renewalDate', { required: 'Field is required' })} />
                                <label htmlFor="Renewal date">Renewal date</label>
                                <p className="error-message">{errors.renewalDate?.message}</p>
                            </div>
                        </Col>
                    </Row>
                </fieldset>
                {/* 7th row */}
                <fieldset className="user-role-form mt-3" style={{ background: "#e1e1e1" }}>
                    <Row className="3">
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="number" autoComplete="off" placeholder="WSIB Account Number" name="wsaibAccountNumber" {...register('wsaibAccountNumber', { required: 'Field is required' })} />
                                <label htmlFor="WSIB Account Number">WSIB Account Number</label>
                                <p className="error-message">{errors.wsaibAccountNumber?.message}</p>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="text" autoComplete="off" placeholder="WSIB Firm" name="wsibFirm" {...register('wsibFirm', { required: 'Field is required' })} />
                                <label htmlFor="WSIB Firm">WSIB Firm</label>
                                <p className="error-message">{errors.wsibFirm?.message}</p>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="date" autoComplete="off" placeholder="WSIB Renewal Date" name="wsibFirmRenewalDate" {...register('wsibFirmRenewalDate', { required: 'Field is required' })} />
                                <label htmlFor="WSIB Renewal Date">WSIB Renewal Date</label>
                                <p className="error-message">{errors.wsibFirmRenewalDate?.message}</p>
                            </div>
                        </Col>
                    </Row>
                </fieldset>
                <fieldset className="user-role-form mt-4 mb-3" style={{ background: "#3c65bb80" }}>
                    <label className="label-heading">Billing Address section</label>
                    <Row>
                        <Col><TextField {...register("billingStreetNo", { required: "Field is Required" })} error={errors.billingStreetNo?.message} label="Street No" /></Col>
                        <Col><TextField {...register("billingStreetName", { required: "Field is Required" })} error={errors.billingStreetName?.message} label="Street Name" /></Col>
                        <AutocompleteAddressData
                            prefix="billing"
                            labelCity="Choose City..."
                            labelProvince="Select Province"
                            labelCountry="Select Country"
                            control={control}
                            register={register}
                            setValue={setValue}
                            errors={errors}
                            cityOptions={billingCityOptions}
                            handleProvince={handleProvince}
                            newHandleCountry={newHandleCountry}
                            interlinerRowData={interlinerRowData}
                            defaultCityID={interlinerRowData?.billingCityID}
                            defaultProvinceID={interlinerRowData?.billingProvinceID}
                            resetHandler={resetHandler}
                        />
                        <Col><TextField  {...register("billingPostalCode", { required: "Field is Required" })} error={errors.billingPostalCode?.message} label="Postal Code" /></Col>
                    </Row>
                </fieldset>
                <fieldset className="user-role-form mt-4 mb-4" style={{ background: "#3c65bb80" }}>
                    <label className="label-heading">Email section</label>
                    <Row>
                        <Col sm={3}>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" id="inlineCheckbox1" name="emailFTProuting" {...register('emailFTProuting')} />
                                <label className="form-check-label" htmlFor="inlineCheckbox1" style={{ fontSize: "15px" }}>Ask to email FTP Routing</label>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                            <Form.Group controlId="drivernumber">
                                <FloatingLabel controlId="floatingSelectGrid" label="Select report type">
                                    <Form.Select aria-label="Floating label select example" name="reportTypeID" {...register('reportTypeID', { required: 'Field is required' })}>
                                        <option value="">Select</option>
                                        <>
                                            {reportType?.data?.map((data, index) => (
                                                <option key={index} value={data.reportTypeID} selected={data?.reportTypeID === interlinerRowData?.reportTypeID}>{data?.reportTypeName}</option>
                                            ))}
                                        </>
                                    </Form.Select>
                                </FloatingLabel>
                                <p className="error-message">{errors.reportTypeID?.message}</p>
                            </Form.Group>
                        </Col>
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="email" autoComplete="off" placeholder="Email" name="email" {...register("email", { required: 'Field is required' })} />
                                <label htmlFor="Email">Email</label>
                                <p className="error-message">{errors.email?.message}</p>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="email" autoComplete="off" placeholder="CC email address" name="ccEmialAddress" {...register('ccEmialAddress', { required: 'Field is required' })} />
                                <label htmlFor="CC email address">CC email address</label>
                                <p className="error-message">{errors.ccEmialAddress?.message}</p>
                            </div>
                        </Col>
                    </Row>
                </fieldset>
                <fieldset className="mb-4 user-role-form" style={{ background: "#3c65bb80" }}>
                    <label className="label-heading">Dock Information</label>
                    <Row>
                        <Col>
                            <div className="form-floating">
                                <Form.Control type="text" autoComplete="off" placeholder="Dock name" name="dockName" {...register('dockName', { required: ' Field is required' })} />
                                <label htmlFor="dockname">Dock name</label>
                                <p className="error-message">{errors.dockName?.message}</p>
                            </div>
                        </Col>
                        <Col><TextField {...register("dockStreetNo", { required: "Field is Required" })} error={errors.dockStreetNo?.message} label="Street No" /></Col>
                        <Col><TextField {...register("dockStreetName", { required: "Field is Required" })} error={errors.dockStreetName?.message} label="Street Name" /></Col>
                        <AutocompleteAddressData
                            prefix="dock"
                            labelCity="Choose City..."
                            labelProvince="Select Province"
                            labelCountry="Select Country"
                            control={control}
                            register={register}
                            setValue={setValue}
                            errors={errors}
                            cityOptions={cityOptions}
                            handleProvince={handleProvince}
                            newHandleCountry={newHandleCountry}
                            interlinerRowData={interlinerRowData}
                            defaultCityID={interlinerRowData?.dockCityID}
                            defaultProvinceID={interlinerRowData?.dockProvinceID}
                            resetHandler={resetHandler}
                        />
                        <Col><TextField  {...register("dockPostalCode", { required: "Field is Required" })} error={errors.dockPostalCode?.message} label="Postal Code" /></Col>
                    </Row>
                </fieldset>
            </>
        </div >
    )
}
export default AddInterliners